<template>
    <v-container>
        <!--    Diálogo Modal Persistente para mostrar la Info de Residente Principal y Residentes    -->
        <v-dialog v-model="dialogInfoMainResidentAndResidents" scrollable max-width="1000px">
            <v-skeleton-loader
                    scrollable max-width="1000px"
                    v-if="loadingSkeleton"
                    type="list-item-two-line, card, image, image, table-tfoot"
            >
            </v-skeleton-loader>
            <v-card v-else class="elevation-5">
                <v-toolbar
                        dark
                        color="primary"
                >
                    <v-toolbar-title>
                        <v-icon
                                right
                                dark
                        >
                            mdi-home-edit
                        </v-icon>
                        {{$t('validar_datos_vivienda')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogInfoMainResidentAndResidents = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text v-if="houseInfo.length > 0">
                    <v-window v-model="step">
                        <v-window-item :value="1">
                            <h2>{{$t('datos_vivienda')}}</h2>
                            <br>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            :label="$t('nombre_calle')"
                                            :value="houseInfo[0].street"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm3>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            :label="$t('numero_casa')"
                                            :value="houseInfo[0].number"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <br>
                            <v-divider></v-divider>
                            <br>
                            <h2>{{$t('datos_residente_principal')}}</h2>
                            <br>
                            <v-layout row wrap>
                                <v-flex
                                        class="pl-3 pr-3 pt-3 pb-3"
                                        xs12 sm6
                                >
                                    <v-img
                                            readonly
                                            outlined
                                            :src="houseInfo[0].main_residents[0].idUser.idFront"
                                    ></v-img>
                                </v-flex>
                                <v-flex
                                        class="pl-3 pr-3 pt-3 pb-3"
                                        xs12 sm6
                                >
                                    <v-img
                                            readonly
                                            outlined
                                            :src="houseInfo[0].main_residents[0].idUser.idBack"
                                    ></v-img>
                                </v-flex>
                            </v-layout>
                            <v-divider></v-divider>
                            <br>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-account"
                                            :label="$t('Nombre')"
                                            :value="houseInfo[0].main_residents[0].idUser.first_name"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-account-outline"
                                            :label="$t('Apellido')"
                                            :value="houseInfo[0].main_residents[0].idUser.last_name"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-email"
                                            label="E-Mail"
                                            :value="houseInfo[0].main_residents[0].idUser.email"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-cellphone"
                                            :label="$t('celular')"
                                            :value="houseInfo[0].main_residents[0].idUser.cellNumber"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-divider></v-divider>
                            <h2>{{$t('datos_residentes')}}</h2>
                            <br>
                            <v-data-table
                                    :headers="headersResident"
                                    :items="houseInfo[0].residents"
                                    class="elevation-1"
                                    :no-data-text="$t('no_records_yet')"
                            >
                                <template v-slot:item.puede_enviar="{ item }">
                                    <v-icon
                                            v-if="item.puede_enviar === true"
                                            medium
                                            color="primary"
                                            class="mr-2"
                                    >
                                        mdi-check
                                    </v-icon>
                                    <v-icon
                                            v-if="item.puede_enviar === false"
                                            medium
                                            color="red"
                                            class="mr-2"
                                    >
                                        mdi-close
                                    </v-icon>
                                    {{ item.puede_enviar ? $t('Si') : 'No' }}
                                </template>
                                <template v-slot:item.action="{ item }">
                                    <v-icon
                                            medium
                                            color="grey"
                                            class="mr-2"
                                            @click="editResident(item)"
                                    >
                                        mdi-account-search
                                    </v-icon>
                                </template>
                            </v-data-table>
                        </v-window-item>
                    </v-window>
                </v-card-text>
                <v-card-actions>
                    {{$t('msg_reconoce_residentes')}}
                    <v-radio-group
                            row
                            v-model="confirm"
                            name="confirm"
                            :mandatory="false"
                    >
                        <v-radio
                                class="pl-3 pr-3"
                                :label="$t('Si')"
                                value=true
                                outlined
                        ></v-radio>
                        <v-radio
                                class="pl-3 pr-3"
                                label="No"
                                value=false
                                outlined
                        ></v-radio>
                    </v-radio-group>
                    <v-btn
                            class="align-center"
                            color="primary"
                            large
                            :loading="loading"
                            @click="activateDeleteUsers()"
                    >
                        {{$t('enviar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo Modal Persistente para mostrar la Info del Pre-residente Principal y Residentes    -->
        <v-dialog v-model="dialogInfoPreMainResidentAndResidents" scrollable max-width="1000px">
            <v-skeleton-loader
                    scrollable max-width="1000px"
                    v-if="loadingSkeleton"
                    type="list-item-two-line, card, image, image, table-tfoot"
            >
            </v-skeleton-loader>
            <v-card v-else class="elevation-5">
                <v-toolbar
                        dark
                        color="primary"
                >
                    <v-toolbar-title>
                        <v-icon
                                right
                                dark
                        >
                            mdi-home-edit
                        </v-icon>
                        {{$t('validar_datos_vivienda')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogInfoPreMainResidentAndResidents = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text v-if="houseInfoPreMainResident.length !== 0">
                    <v-window v-model="step">
                        <v-window-item :value="1">
                            <h2>{{$t('datos_vivienda')}}</h2>
                            <br>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            :label="$t('nombre_calle')"
                                            :value="houseInfoPreMainResident.idHouse.street"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm3>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            :label="$t('numero_casa')"
                                            :value="houseInfoPreMainResident.idHouse.number"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <br>
                            <v-divider></v-divider>
                            <br>
                            <h2>{{$t('datos_residente_principal')}}</h2>
                            <br>
                            <v-layout row wrap>
                                <v-flex
                                        class="pl-3 pr-3 pt-3 pb-3"
                                        xs12 sm6
                                >
                                    <v-img
                                            readonly
                                            outlined
                                            :src="houseInfoPreMainResident.idUser.idFront"
                                    ></v-img>
                                </v-flex>
                                <v-flex
                                        class="pl-3 pr-3 pt-3 pb-3"
                                        xs12 sm6
                                >
                                    <v-img
                                            readonly
                                            outlined
                                            :src="houseInfoPreMainResident.idUser.idBack"
                                    ></v-img>
                                </v-flex>
                            </v-layout>
                            <v-divider></v-divider>
                            <br>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-account"
                                            :label="$t('Nombre')"
                                            :value="houseInfoPreMainResident.idUser.first_name"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-account-outline"
                                            :label="$t('Apellido')"
                                            :value="houseInfoPreMainResident.idUser.last_name"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-email"
                                            label="E-Mail"
                                            :value="houseInfoPreMainResident.idUser.email"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-cellphone"
                                            :label="$t('celular')"
                                            :value="houseInfoPreMainResident.idUser.cellNumber"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-window-item>
                    </v-window>
                </v-card-text>
                <v-card-actions>
                    {{$t('msg_reconoce_residentes')}}
                    <v-radio-group
                            row
                            v-model="confirm"
                            name="confirm"
                            :mandatory="false"
                    >
                        <v-radio
                                class="pl-3 pr-3"
                                :label="$t('Si')"
                                value=true
                                outlined
                        ></v-radio>
                        <v-radio
                                class="pl-3 pr-3"
                                label="No"
                                value=false
                                outlined
                        ></v-radio>
                    </v-radio-group>
                    <v-btn
                            class="align-center"
                            color="primary"
                            large
                            :loading="loading"
                            @click="activateDeleteUsersPreMainResident()"
                    >
                        {{$t('enviar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo Modal  Confirmar   -->
        <v-dialog v-model="dialogConfirm" max-width="290">
            <v-card>
                <v-card-title class="headline">{{$t('aviso')}}</v-card-title>
                <v-card-text align="center">
                    {{$t('msg_confirma_validacion_1')}} <b>{{$t('Si')}}</b> {{$t('or')}} <b> No </b> {{$t('msg_confirma_validacion_2')}}<br><br>
                    <v-btn color="primary" @click="dialogConfirm = false">{{$t('aceptar')}}</v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!--    Diálogo Modal para mostrar a los Residente(s)    -->
        <v-dialog v-model="dialog_residente" scrollable max-width="400">
            <v-card>
                <v-toolbar dark  color="primary">
                    <v-toolbar-title>
                        {{$t('detalle_residente')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            icon
                            @click="dialog_residente = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="mt-5">
                    <v-layout row wrap>
                        <v-flex xs12>
                        <v-flex
                            class="pl-3 pr-3 pt-3 pb-3"
                            xs12
                        >
                            <div class="wrapper">
                                <v-img
                                        :src="editedItem.idUser.avatar"
                                ></v-img>
                            </div>
                        </v-flex>
                            <v-text-field
                                    class="pl-3 pr-3"
                                    prepend-icon="mdi-account"
                                    :label="$t('Nombre')"
                                    :value="editedItem.idUser.first_name"
                                    readonly
                                    outlined
                            >
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                    class="pl-3 pr-3"
                                    prepend-icon="mdi-account-outline"
                                    :label="$t('Apellido')"
                                    :value="editedItem.idUser.last_name"
                                    readonly
                                    outlined
                            >
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                    class="pl-3 pr-3"
                                    prepend-icon="mdi-cellphone"
                                    :label="$t('celular')"
                                    :value="editedItem.idUser.cellNumber"
                                    readonly
                                    outlined
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                    class="pl-3 pr-3"
                                    prepend-icon="mdi-email"
                                    label="E-Mail"
                                    :value="editedItem.idUser.email"
                                    readonly
                                    outlined
                            ></v-text-field>
                        </v-flex>
<!--                        <v-flex xs12>-->
<!--                            <v-checkbox-->
<!--                                    class="pl-3 pr-3"-->
<!--                                    :label="$t('puede_enviar')"-->
<!--                                    v-model="editedItem.puede_enviar"-->
<!--                                    readonly-->
<!--                                    outlined-->
<!--                            ></v-checkbox>-->
<!--                        </v-flex>-->
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!--    Diálogo  Modal para mostrar mensaje Número de Celular incorrecto    -->
        <v-dialog v-model="dialogCellNumberWrong" max-width="290">
            <v-card>
                <v-card-title class="headline">{{$t('aviso')}}</v-card-title>
                <v-card-text>{{$t('cellphone_wrong')}}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialogCellNumberWrong = false">{{$t('aceptar')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo  Modal para Cambiar Permisos (Usuario -> Residente Principal)    -->
        <v-dialog v-model="dialogMoveUp" max-width="500">
            <v-form @submit.prevent="moveUpUserToMainResident()">
                <v-card class="elevation-5">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('move_up_user_to_main_resident')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialogMoveUp = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-layout row wrap>
                            <v-autocomplete
                                    v-model="emailGuest"
                                    :items="items"
                                    prepend-icon="mdi-email"
                                    :loading="isLoading"
                                    :search-input.sync="search2"
                                    :item-text="example"
                                    item-value="id"
                                    :placeholder="$t('placeholder_invitados2')"
                                    :label="$t('usuarios')"
                                    :error-messages="errores.idUser"
                                    :no-data-text="$t('no_resultados')"
                                    clearable
                                    autocomplete="off"
                            >
                                <template v-slot:selection="data">
                                    <v-chip
                                            v-bind="data.attrs"
                                            :input-value="data.selected"
                                            @click="data.select"
                                    >
                                        <v-avatar left>
                                            <v-img :src="data.item.avatar"></v-img>
                                        </v-avatar>
                                        {{ data.item.first_name }} {{data.item.last_name}}
                                    </v-chip>
                                </template>
                                <template v-slot:item="data">
                                    <template v-if="typeof data.item !== 'object'">
                                        <v-list-item-content v-text="data.item"></v-list-item-content>
                                    </template>
                                    <template v-else>
                                        <v-list-item-avatar>
                                            <img :src="data.item.avatar">
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ data.item.first_name }} {{data.item.last_name}}</v-list-item-title>
                                            <v-list-item-sub-title v-html="data.item.group"></v-list-item-sub-title>
                                        </v-list-item-content>
                                    </template>
                                </template>
                            </v-autocomplete>
                            <v-autocomplete
                                    v-model="id_house"
                                    prepend-icon="mdi-home"
                                    name="id_house"
                                    :item-text="example2"
                                    item-value="id"
                                    :label="$t('casas')"
                                    :placeholder="$t('search_by_house_number')"
                                    :filter="customFilter"
                                    :error-messages="errores.idHouse"
                                    :items="houses"
                                    no-data-text="Ningún Resultado"
                                    clearable
                                    autocomplete="off"
                            >
                                <template v-slot:item="data">
                                    <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}} ( {{data.item.phone === null ? 'n/a' : data.item.phone}} )</strong>
                                </template>
                            </v-autocomplete>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                                color="primary"
                                @click="dialogMoveUp = false"
                        >
                            {{$t('cerrar')}}
                        </v-btn>
                        <v-spacer/>
                        <v-btn
                                color="primary"
                                type="submit"
                                :loading="loading"
                        >
                            {{$t('modificar')}}
                            <v-icon dark right>mdi-swap-horizontal</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!--    Diálogo  Modal para Actualizar Códigos de Residentes Periódicamente    -->
        <v-dialog v-model="dialogUpdateQRCodes" max-width="500">
            <v-form @submit.prevent="updateQRCodes()">
                <v-card class="elevation-5">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('renovar_codigos_residentes')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialogUpdateQRCodes = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text class="text-center">
                        <p>
                            {{$t('msg_update_code_1')}}
                            <br><br>
                            {{$t('msg_update_code_2')}}
                        </p>
                        <v-layout align-center justify-center fill-height>
                            <v-switch
                                    v-model="QRCodes"
                                    :label="$t('allow')">
                            </v-switch>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                                color="primary"
                                @click="dialogUpdateQRCodes = false"
                        >
                            {{$t('cerrar')}}
                        </v-btn>
                        <v-spacer/>
                        <v-btn
                                color="primary"
                                type="submit"
                                :loading="loadingQRCodes"
                        >
                            {{$t('modificar')}}
                            <v-icon dark right>mdi-calendar-clock</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!--   Diálogo para Mostrar un mensaje al Eliminar Residente Principal     -->
        <v-dialog
                v-model="deleteDialog"
                max-width="450"
        >
            <v-card>
                <v-card-title class="headline">
                    {{$t('msg_delete_main_resident')}}
                </v-card-title>

                <v-card-text>
                    {{$t('msg_accion_deshacer')}}
                </v-card-text>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            @click="deleteDialog = false"
                    >
                        No
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            @click="deleteMainResident()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--   Diálogo para Mostrar un mensaje al Activar/Desactivar Residente Principal     -->
        <v-dialog
                v-model="dialogEnableDisable"
                max-width="600"
        >
            <v-card>
                <v-toolbar dark :color=" enable === true ? 'primary' : 'warning'">
                    <v-toolbar-title>
                        {{$t('aviso')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogEnableDisable = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-title class="headline">
                    <div v-if="enable === true">
                        {{$t('msg_enable_main_resident')}}
                    </div>
                    <div v-else-if="disable=== true">
                        {{$t('msg_disable_main_resident')}}
                    </div>
                </v-card-title>
                <v-card-text v-if="enable === true">
                    {{$t('note_enable_main_resident')}}
                </v-card-text>
                <v-card-text v-else-if="disable === true">
                    {{$t('note_disable_main_resident')}}
                </v-card-text>
                <v-card-actions>
                    <v-btn
                            outlined
                            color="black"
                            @click="dialogEnableDisable = false"
                    >
                        No
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            outlined
                            color="black"
                            @click="enableDisableMainResident()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Frontal      -->
        <v-dialog v-model="dialogImageFront" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            :rotate="degrees"
                            :ratio="ratio"
                            ref="clipperImageFront"
                            :src="imageFrontURL">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center"> <v-col>
                    <v-row xs12 class="justify-center">
                        <v-radio-group
                                v-model="ratio"
                                name="ratio"
                                row
                                label="Ratio"
                                :mandatory="false"
                        >
                            <v-radio label="1:1" value="1"></v-radio>
                            <v-radio label="3:2" value="1.5"></v-radio>
                            <v-radio label="4:3" value="1.3333333333333333"></v-radio>
                            <v-radio label="16:9" value="1.7777777777777777"></v-radio>
                        </v-radio-group>
                    </v-row>
                    <v-row xs12 class="justify-center mr-6">
                        <v-slider
                                v-model="degrees"
                                :label="$t('grados')"
                                step="1"
                                max="180"
                                min="-180"
                                thumb-label="always"
                        ></v-slider>
                    </v-row>
                    <v-row class="justify-center">
                        <v-btn
                                color="primary"
                                @click="getCutingFront()"
                        >{{$t('recortar')}}</v-btn>
                    </v-row>
                </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Atrás      -->
        <v-dialog v-model="dialogImageBack" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            :rotate="degrees"
                            :ratio="ratio"
                            ref="clipperImageBack"
                            :src="imageBackURL">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center">
                            <v-radio-group
                                    v-model="ratio"
                                    name="ratio"
                                    row
                                    label="Ratio"
                                    :mandatory="false"
                            >
                                <v-radio label="1:1" value="1"></v-radio>
                                <v-radio label="3:2" value="1.5"></v-radio>
                                <v-radio label="4:3" value="1.3333333333333333"></v-radio>
                                <v-radio label="16:9" value="1.7777777777777777"></v-radio>
                            </v-radio-group>
                        </v-row>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row xs12 class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingBack()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Foto de perfil      -->
        <v-dialog v-model="dialogImageProfile" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            class="basic lg"
                            :src="imageProfileURL"
                            ref="clipperImageProfile"
                            :rotate="degrees"
                            :round="true"
                            preview="preview">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row xs12 class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingProfile()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
<!--        <h2 class="subheading grey&#45;&#45;text">{{ $t('main_residents') }}</h2>-->
        <v-layout align-center justify-center fill-height>
            <v-dialog v-model="dialog" persistent scrollable max-width="600px">
                <template v-slot:activator="{ on }">
<!--                    <v-layout row wrap class="justify-center">-->
<!--                        <v-btn-->
<!--                                color="primary"-->
<!--                                dark-->
<!--                                v-on="on"-->
<!--                                @click="update = false,-->
<!--                                cleanFields(), getHouses()"> + {{ $t('anadir_main_resident') }}-->
<!--                        </v-btn>-->
<!--                        <v-btn-->
<!--                                arrow_upward-->
<!--                                color="primary"-->
<!--                                @click="dialogMoveUp = true, getHouses(), emailGuest = '', id_house = '', entries = [], errores = [] "-->
<!--                        >-->
<!--                            <v-icon dark left>mdi-swap-horizontal</v-icon>-->
<!--                            {{$t('cambiar_permisos')}}-->
<!--                        </v-btn>-->
<!--                        <v-btn-->
<!--                                color="primary"-->
<!--                                @click="getStatusUpdateQRCode(), dialogUpdateQRCodes = true"-->
<!--                        >-->
<!--                            <v-icon dark left>mdi-calendar-clock</v-icon>-->
<!--                            {{$t('renovar_codigos')}}-->
<!--                        </v-btn>-->
<!--                    </v-layout>-->
                </template>
                <v-form @submit.prevent="update
                                        ? updateMainResident(id_update)
                                        : createMainResident()">
                    <v-card class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>
                                {{ $t('residente_principal') }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="clear(), dialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-autocomplete
                                    v-if="update === false"
                                    v-model="id_house"
                                    prepend-icon="mdi-home-city"
                                    name="id_house"
                                    :item-text="example2"
                                    item-value="id"
                                    :label="$t('casas')"
                                    :placeholder="$t('search_by_house_number')"
                                    :filter="customFilter"
                                    :error-messages="errores.idHouse"
                                    :items="houses"
                                    no-data-text="Ningún Resultado"
                                    clearable
                            >
                                <template v-slot:item="data">
                                    <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}} ( {{data.item.phone === null ? 'n/a' : data.item.phone}} )</strong>
                                </template>
                            </v-autocomplete>
                            <v-text-field
                                    v-model="first_name"
                                    prepend-icon="mdi-account"
                                    name="first_name"
                                    :label="$t('Nombre')"
                                    :error-messages="errores_seg.first_name"
                            >
                            </v-text-field>
                            <v-text-field
                                    v-model="last_name"
                                    prepend-icon="mdi-account-outline"
                                    name="last_name"
                                    :label="$t('Apellido')"
                                    :error-messages="errores_seg.last_name"
                            >
                            </v-text-field>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">
                                    <v-label>
                                        {{$t('foto_ine')}}<br>[{{$t('frente')}}]
                                    </v-label>
                                    <br>
                                    <v-img
                                            class="pt-3 pb-3"
                                            :src="resultFrontURL"
                                            v-if="resultFrontURL"
                                            width="auto"
                                            height="180"
                                    ></v-img>
                                    <br>
                                    <v-btn
                                            color="primary">
                                        <clipper-upload
                                                @input="dialog = false, dialogImageFront = true, degrees = 0, ratio = '1'"
                                                accept="image/*"
                                                v-model="imageFrontURL"
                                        >
                                            {{$t('subir_imagen')}}
                                        </clipper-upload>
                                    </v-btn>
                                    <br>
                                    <v-alert
                                            v-if="errores_seg.idFront"
                                            type="error"
                                            outlined
                                            transition="scale-transition"
                                    >
                                        {{errores_seg.idFront}}
                                    </v-alert>
                                </v-flex>
                                <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">
                                    <v-label>
                                        {{$t('foto_ine')}}<br>[{{$t('atras')}}]
                                    </v-label>
                                    <br>
                                    <v-img
                                            class="pt-3 pb-3"
                                            :src="resultBackURL"
                                            v-if="resultBackURL"
                                            width="auto"
                                            height="180"
                                    ></v-img>
                                    <br>
                                    <v-btn
                                            color="primary">
                                        <clipper-upload
                                                @input="dialog = false, dialogImageBack = true, degrees = 0, ratio = '1'"
                                                accept="image/*"
                                                v-model="imageBackURL"
                                        >
                                            {{$t('subir_imagen')}}
                                        </clipper-upload>
                                    </v-btn>
                                    <br>
                                    <v-alert
                                            v-if="errores_seg.idBack"
                                            type="error"
                                            outlined
                                            transition="scale-transition"
                                    >
                                        {{errores_seg.idBack}}
                                    </v-alert>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">
                                    <div class="splash-info">
                                        <v-label>
                                            {{$t('foto_perfil')}}
                                        </v-label>
                                        <br>
                                        <div class="wrapper">
                                            <img
                                                    :src="resultProfileURL"
                                                    v-if="resultProfileURL">
                                        </div>
                                        <br>
                                        <v-btn
                                                color="primary">
                                            <clipper-upload
                                                    @input="dialog = false, dialogImageProfile = true, degrees = 0, ratio = '1'"
                                                    accept="image/*"
                                                    v-model="imageProfileURL"
                                            >
                                                {{$t('subir_imagen')}}
                                            </clipper-upload>
                                        </v-btn>
                                        <br>
                                        <v-alert
                                                v-if="errores_seg.avatar"
                                                type="error"
                                                outlined
                                                transition="scale-transition"
                                        >
                                            {{errores_seg.avatar}}
                                        </v-alert>
                                    </div>
                                </v-flex>
                            </v-layout>
                            <vue-tel-input
                                    class="mt-3 mb-3"
                                    v-model="celular"
                                    @onInput="onInput"
                            >
                                <v-alert v-if="errores_seg.cellNumber" type="error">{{errores_seg.cellNumber}}</v-alert>
                            </vue-tel-input>
                            <v-alert outlined v-if="errores_seg.cellNumber" type="error">{{errores_seg.cellNumber}}</v-alert>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <v-text-field
                                            autocomplete="username"
                                            v-model="email"
                                            prepend-icon="mdi-email"
                                            name="email"
                                            label="E-Mail"
                                            :error-messages="errores_seg.email"
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-checkbox
                                    v-model="change_password"
                                    v-if="update" disable
                                    name="change_password"
                                    label="Cambiar Contraseña"
                            ></v-checkbox>
                            <ValidationObserver>
                                <ValidationProvider :rules="change_password ? 'required|password:@confirm' : ''" v-slot="{ errors }">
                                    <v-text-field
                                            autocomplete="new-password"
                                            v-model="password"
                                            :disabled="update && !change_password ? true: false"
                                            prepend-icon="mdi-lock"
                                            :label="$t('password')"
                                            :type="show ? 'text' : 'password'"
                                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                            @click:append="show = !show"
                                            :error-messages="change_password ? errores_seg.password : ''">
                                    </v-text-field>
                                    <span>{{ errors[0] }}</span>
                                </ValidationProvider>
                                <ValidationProvider name="confirm" :rules="change_password ? 'required' : ''" v-slot="{ errors }">
                                    <v-text-field
                                            autocomplete="new-password"
                                            v-model="confirmation"
                                            :disabled="update  && !change_password ? true: false"
                                            prepend-icon="mdi-lock"
                                            :label="$t('password_confirm')"
                                            :type="show ? 'text' : 'password'"
                                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                            @click:append="show = !show">
                                    </v-text-field>
                                    <span>{{ errors[0] }}</span>
                                </ValidationProvider>
                            </ValidationObserver>
                            <v-alert
                                    :value=alerta
                                    type="warning"
                                    outlined
                                    transition="scale-transition"
                            >
                                Fallo con el Servidor
                            </v-alert>
                        </v-card-text>
                        <v-card-actions>
                            <v-btn
                                    color="primary"
                                    @click="clear(),
                                            dialog = false"
                            >{{$t('cerrar')}}
                            </v-btn>
                            <v-spacer/>
                            <v-btn
                                    v-if="update"
                                    :loading="loading"
                                    color="primary"
                                    type="submit"
                            >{{$t('modificar')}}
                            </v-btn>
                            <v-btn
                                    v-else
                                    :loading="loading"
                                    color="primary"
                                    type="submit"
                            >{{$t('agregar')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-layout>
        <v-card>
          <v-card-text>
            <v-layout align-center justify-center fill-height>
              <v-flex v-if="mainResidents.length > 0">
                <v-carousel
                    height="auto"
                    hide-delimiter-background
                    show-arrows-on-hover
                    hide-delimiters
                >
                  <v-carousel-item
                      v-for="(item,i) in mainResidents"
                      :key="i"
                  >
                    <v-card light>
                      <v-toolbar color="blue">
                        <v-toolbar-title>
                          {{ $t('residente_principal') }}
                          [  {{i + 1}} {{$t('de')}} {{mainResidents.length}}]  -  ({{mainResidents[i].street}} {{mainResidents[i].number}})
                        </v-toolbar-title>
                      </v-toolbar>
                      <v-card-text>
                        <v-layout row wrap>
                          <v-flex xs6 class="text-center">
                            <v-label>
                              {{$t('foto_perfil')}}
                            </v-label>
                            <br><br><br>
                            <v-avatar size="300px">
                              <img
                                  :src="resultProfileURL"
                                  v-if="resultProfileURL"
                              >
                            </v-avatar>
                            <br><br>
                            <v-alert
                                v-if="errores_seg.avatar"
                                type="error"
                                outlined
                                transition="scale-transition"
                            >
                              {{errores_seg.avatar}}
                            </v-alert>
                            <v-btn
                                color="blue">
                              <clipper-upload
                                  @input="dialog = false, dialogImageProfile = true, degrees = 0, ratio = '1'"
                                  accept="image/*"
                                  v-model="imageProfileURL"
                              >
                                {{$t('subir_imagen')}}
                              </clipper-upload>
                            </v-btn>
                            <br>
                          </v-flex>
                          <v-flex xs6>
                            <v-autocomplete
                                outlined
                                v-if="update === false"
                                v-model="id_house"
                                prepend-icon="mdi-home-city"
                                name="id_house"
                                :item-text="example2"
                                item-value="id"
                                :label="$t('casas')"
                                :placeholder="$t('search_by_house_number')"
                                :filter="customFilter"
                                :error-messages="errores.idHouse"
                                :items="houses"
                                no-data-text="Ningún Resultado"
                                clearable
                            >
                              <template v-slot:item="data">
                                <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}} ( {{data.item.phone === null ? 'n/a' : data.item.phone}} )</strong>
                              </template>
                            </v-autocomplete>
                            <v-text-field
                                outlined
                                v-model="item.first_name"
                                prepend-icon="mdi-account"
                                name="first_name"
                                :label="$t('Nombre')"
                                :error-messages="errores_seg.first_name"
                            >
                            </v-text-field>
                            <v-text-field
                                outlined
                                v-model="item.last_name"
                                prepend-icon="mdi-account-outline"
                                name="last_name"
                                :label="$t('Apellido')"
                                :error-messages="errores_seg.last_name"
                            >
                            </v-text-field>
                            <vue-tel-input
                                class="mt-3 mb-3 ml-8"
                                v-model="item.celular"
                                @onInput="onInput"
                            >
                              <v-alert v-if="errores_seg.cellNumber" type="error">{{errores_seg.cellNumber}}</v-alert>
                            </vue-tel-input>
                            <v-alert outlined v-if="errores_seg.cellNumber" type="error">{{errores_seg.cellNumber}}</v-alert>
                            <v-text-field
                                outlined
                                autocomplete="username"
                                v-model="item.email"
                                prepend-icon="mdi-email"
                                name="email"
                                label="E-Mail"
                                :error-messages="errores_seg.email"
                            >
                            </v-text-field>
                            <v-checkbox
                                v-model="change_password"
                                v-if="update" disable
                                name="change_password"
                                label="Cambiar Contraseña"
                            ></v-checkbox>
                            <ValidationObserver>
                              <ValidationProvider :rules="change_password ? 'required|password:@confirm' : ''" v-slot="{ errors }">
                                <v-text-field
                                    autocomplete="new-password"
                                    outlined
                                    v-model="item.password"
                                    :disabled="update && !change_password ? true: false"
                                    prepend-icon="mdi-lock"
                                    :label="$t('password')"
                                    :type="show ? 'text' : 'password'"
                                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                    @click:append="show = !show"
                                    :error-messages="change_password ? errores_seg.password : ''">
                                </v-text-field>
                                <span>{{ errors[0] }}</span>
                              </ValidationProvider>
                              <ValidationProvider name="confirm" :rules="change_password ? 'required' : ''" v-slot="{ errors }">
<!--                                <v-text-field-->
<!--                                    outlined-->
<!--                                    autocomplete="new-password"-->
<!--                                    v-model="confirmation"-->
<!--                                    :disabled="update  && !change_password ? true: false"-->
<!--                                    prepend-icon="mdi-lock"-->
<!--                                    :label="$t('password_confirm')"-->
<!--                                    :type="show ? 'text' : 'password'"-->
<!--                                    :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"-->
<!--                                    @click:append="show = !show">-->
<!--                                </v-text-field>-->
                                <span>{{ errors[0] }}</span>
                              </ValidationProvider>
                            </ValidationObserver>
                          </v-flex>
                        </v-layout>
                      </v-card-text>
                      <v-card-actions>
<!--                        <v-btn-->
<!--                            color="primary"-->
<!--                            @click="clear(),-->
<!--                                            dialog = false"-->
<!--                        >{{$t('cerrar')}}-->
<!--                        </v-btn>-->
<!--                        <v-spacer/>-->
                        <v-btn
                            v-if="update"
                            :loading="loading"
                            color="blue"
                            type="submit"
                        >{{$t('modificar')}}
                        </v-btn>
                        <v-btn
                            v-else
                            block
                            :loading="loading"
                            color="blue"
                            @click="autocompleteDataMainResident(item), createMainResident()"
                        >{{$t('agregar')}}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-carousel-item>
                </v-carousel>
              </v-flex>
            </v-layout>
          </v-card-text>
        </v-card>
    </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import VuejsClipper from 'vuejs-clipper'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { mapState, mapGetters } from 'vuex'
import Vue from 'vue'
import { required } from 'vee-validate/dist/rules'

extend('password', {
  params: ['target'],
  validate (value, { target }) {
    return value === target
  },
  message: 'Password confirmation does not match'
})

extend('required', {
  ...required,
  message: 'This field is required'
})

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.use(VuejsClipper, {
  components: {
    clipperBasic: 'clipper-basic',
    clipperFixed: 'clipper-fixed',
    clipperUpload: 'clipper-upload'
  }
})

export default {
  name: 'main_residents_2',
  created: function () {
    this.getProfileData()
  },
  data: () => ({
    show: false,
    alerta: false,
    dialog: false,
    update: false,
    id_update: 0,
    id_house: '',
    first_name: '',
    last_name: '',
    celular: '',
    email: '',
    email_aux: '',
    celular_aux: '',
    password: '',
    errores: [],
    errores_seg: [],
    houses: [],
    preMainResidents: [],
    change_password: '',
    loadingDataMainResidents: false,
    loading: false,
    confirmation: '',
    search: '',
    searchPreMainResidents: '',
    // Imágenes
    dialogImageFront: false,
    dialogImageBack: false,
    dialogImageProfile: false,
    imageFrontURL: '',
    imageBackURL: '',
    imageProfileURL: '',
    resultFrontURL: '',
    resultBackURL: '',
    resultProfileURL: '',
    resultAuxFrontURL: '',
    resultAuxBackURL: '',
    resultAuxProfileURL: '',
    // Delete MainResident
    deleteDialog: false,
    idMainResidentDelete: 0,
    // Move Up
    dialogMoveUp: false,
    emailGuest: '',
    isLoading: false,
    search2: null,
    entries: [],
    band_cellphone: false,
    dialogCellNumberWrong: false,
    // Info Main Resident and Residents
    step: 1,
    residentes: [],
    headersResident: [],
    dialog_residente: false,
    editedIndex: -1,
    editedItem: {
      idUser: {
        first_name: '',
        last_name: '',
        email: '',
        cellNumber: '',
        puede_enviar: false,
        avatar: ''
      }
    },
    houseInfo: [],
    houseInfoPreMainResident: [],
    confirm: null,
    dialogConfirm: false,
    dialogInfoMainResidentAndResidents: false,
    dialogInfoPreMainResidentAndResidents: false,
    temporalToken: '',
    temporalId: '',
    profileData: {},
    loadingSkeleton: false,
    dialogEnableDisable: false,
    disable: false,
    enable: false,
    idHouse: 0,
    dialogUpdateQRCodes: false,
    QRCodes: null,
    loadingQRCodes: false,
    degrees: 0,
    ratio: '1',
    bandPreMainResident: false,
    ine: 'data:image/jpeg;base64,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',
    mainResidents: [
      {
        street: 'Calle sin nombre',
        number: '2',
        first_name: 'VICTOR MANUEL',
        last_name: 'CRUZ FAZ',
        email: 'faker0001@mail.com',
        password: '115v109',
        celular_2: '8887770001',
        celular: '+528887770001'
      },
      {
        street: 'Calle sin nombre',
        number: '3',
        first_name: 'FERNANDO',
        last_name: 'GORDO',
        email: 'faker0002@mail.com',
        password: '110i103',
        celular_2: '8887770002',
        celular: '+528887770002'
      }
    ]
  }),
  beforeUpdate () {
    this.headersResident = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('Nombre'),
        align: 'center',
        sortable: true,
        value: 'idUser.first_name'
      },
      {
        text: this.$t('Apellido'),
        align: 'center',
        sortable: true,
        value: 'idUser.last_name'
      },
      {
        text: this.$t('celular'),
        align: 'center',
        sortable: true,
        value: 'idUser.cellNumber'
      },
      {
        text: 'E-Mail',
        align: 'center',
        sortable: true,
        value: 'idUser.email'
      }
    ]
  },
  computed: {
    headers () {
      return [
        {
          text: this.$t('acciones'),
          align: 'center',
          value: 'action',
          sortable: false
        },
        {
          text: this.$t('validado'),
          align: 'center',
          sortable: true,
          value: 'temporalToken'
        },
        {
          text: this.$t('activar_desactivar'),
          align: 'center',
          sortable: true,
          value: 'can_send'
        },
        {
          text: this.$t('numero_casa'),
          align: 'left',
          sortable: true,
          value: 'street'
        },
        {
          text: this.$t('Nombre'),
          align: 'left',
          sortable: true,
          value: 'idUser.first_name'
        },
        {
          text: this.$t('Apellido'),
          align: 'left',
          sortable: true,
          value: 'idUser.last_name'
        },
        {
          text: this.$t('celular'),
          align: 'left',
          sortable: true,
          value: 'idUser.cellNumber'
        },
        {
          text: 'E-Mail',
          align: 'left',
          sortable: true,
          value: 'idUser.email'
        }
      ]
    },
    headers2 () {
      return [
        {
          text: this.$t('acciones'),
          align: 'center',
          value: 'action',
          sortable: false
        },
        {
          text: this.$t('validado'),
          align: 'center',
          sortable: true,
          value: 'temporalToken'
        },
        {
          text: this.$t('numero_casa'),
          align: 'left',
          sortable: true,
          value: 'street'
        },
        {
          text: this.$t('Nombre'),
          align: 'left',
          sortable: true,
          value: 'idUser.first_name'
        },
        {
          text: this.$t('Apellido'),
          align: 'left',
          sortable: true,
          value: 'idUser.last_name'
        },
        {
          text: this.$t('celular'),
          align: 'left',
          sortable: true,
          value: 'idUser.cellNumber'
        },
        {
          text: 'E-Mail',
          align: 'left',
          sortable: true,
          value: 'idUser.email'
        }
      ]
    },
    currentTitle () {
      switch (this.step) {
        case 1: return this.$t('datos_vivienda')
        case 2: return this.$t('datos_residente_principal')
        default: return this.$t('datos_residentes')
      }
    },
    ...mapState(['language']),
    ...mapGetters(['getProfile']),
    fields () {
      if (!this.emailGuest) return []

      return Object.keys(this.emailGuest).map(key => {
        return {
          key,
          value: this.emailGuest[key] || 'n/a'
        }
      })
    },
    items () {
      return this.entries.map(entry => {
        const email = entry.first_name.length > this.descriptionLimit
          ? entry.first_name.slice(0, this.descriptionLimit) + '...'
          : entry.first_name

        return Object.assign({}, entry, { email })
      })
    }
  },
  watch: {
    isUpdating (val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000)
      }
    },
    search2 (val) {
      if (val.length > 2) {
        this.isLoading = true
        // Lazily load input items
        const config = {
          method: 'get',
          url: 'https://residencial-services.intrare.app/guests/filter?search=' + val,
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
          }
        }
        axios(config)
          .then(response => {
            console.log(response.data)
            if (this.entries.length > 0) {
              for (var i = 0; i < response.data.length; i++) {
                this.entries.push(response.data[i])
              }
            } else {
              this.entries = response.data
            }
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => (this.isLoading = false))
      }
    }
  },
  methods: {
    getProfileData () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/users/me/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.profileData = response.data
          this.getHouses()
        })
        .catch(error => {
          console.log(error)
        })
    },
    getHouses: function () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/house/' + this.profileData.idHousingUnit + '/housingunit/',
        headers: {
          'Content-Type': 'application/json'
        }
      }
      axios(config)
        .then(response => {
          this.houses = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getMainResidents: function () {
      this.loadingDataMainResidents = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/principal_resident/v2/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.mainResidents = response.data.principalResident
          this.preMainResidents = response.data.prePrincipalResident
          this.loadingDataMainResidents = false
        })
        .catch(error => {
          this.loadingDataMainResidents = false
          console.log(error)
        })
    },
    autocompleteDataMainResident (item) {
      this.first_name = item.first_name
      this.last_name = item.last_name
      this.email = item.email
      this.password = item.password
    },
    createMainResident: function () {
      if (this.id_house === '') {
        this.id_house = null
      }
      this.errores = []
      this.errores_seg = []
      if (this.band_cellphone === true) {
        this.loading = true
        var bodyFormData = new FormData()
        var fileImageFront = null
        var fileImageBack = null
        var fileImageProfile = null

        bodyFormData.set('idUser.first_name', this.first_name)
        bodyFormData.set('idUser.last_name', this.last_name)
        bodyFormData.set('idUser.cellNumber', this.celular)
        bodyFormData.set('idUser.email', this.email.toLowerCase())
        bodyFormData.set('idUser.password', this.password)
        bodyFormData.set('idHouse', this.id_house)
        this.resultFrontURL = this.ine
        if (this.resultFrontURL !== '' && this.resultFrontURL.length > 6) {
          fileImageFront = this.dataURLtoFile(this.resultFrontURL, 'ine_front.jpeg')
        }
        bodyFormData.append('idUser.idFront', fileImageFront)
        this.resultBackURL = this.ine
        if (this.resultBackURL !== '' && this.resultBackURL.length > 6) {
          fileImageBack = this.dataURLtoFile(this.resultBackURL, 'ine_back.jpeg')
        }
        bodyFormData.append('idUser.idBack', fileImageBack)
        if (this.resultProfileURL !== '' && this.resultProfileURL.length > 6) {
          fileImageProfile = this.dataURLtoFile(this.resultProfileURL, 'avatar.jpeg')
        }
        bodyFormData.append('idUser.avatar', fileImageProfile)
        const config = {
          method: 'post',
          url: 'https://residencial-services.intrare.app/principal_resident/',
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language,
            'authorization': 'Token ' + store.getters.getToken
          },
          data: bodyFormData
        }
        axios(config)
          .then(ok => {
            this.loading = false
            this.getHouses()
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('mensaje_mainresident_alta'))
            this.dialog = false
            setTimeout(this.clear, 3000)
          })
          .catch(error => {
            this.loading = false
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              if (error.response.data) {
                this.errores = error.response.data
              }
              if (error.response.data.idUser) {
                this.errores_seg = error.response.data.idUser
              }
            }
          })
      } else {
        this.dialogCellNumberWrong = true
      }
    },
    updateMainResident: function (id) {
      if (this.band_cellphone === true) {
        this.errores = []
        this.errores_seg = []
        this.loading = true
        var bodyFormData = new FormData()
        var fileImageFront = null
        var fileImageBack = null
        var fileImageProfile = null
        // Evitar Campo Fraccionamiento vacío
        if (this.id_house === undefined) {
          this.id_house = ''
        }
        if (this.email_aux !== this.email) {
          // idUser['email'] = this.email.toLowerCase()
          bodyFormData.set('idUser.email', this.email.toLowerCase())
        }
        if (this.celular_aux !== this.celular) {
          bodyFormData.set('idUser.cellNumber', this.celular)
          // idUser['cellNumber'] = this.celular
        }
        if (this.change_password === true) {
          bodyFormData.set('idUser.password', this.password)
          // idUser['password'] = this.password
        }
        if (this.resultFrontURL !== this.resultAuxFrontURL) {
          const newID = this.$uuid.v4()
          if (this.resultFrontURL !== '' && this.resultFrontURL.length > 6) {
            fileImageFront = this.dataURLtoFile(this.resultFrontURL, 'ine_front' + newID + '.jpeg')
          }
          bodyFormData.append('idUser.idFront', fileImageFront)
        }
        if (this.resultBackURL !== this.resultAuxBackURL) {
          const newID = this.$uuid.v4()
          if (this.resultBackURL !== '' && this.resultBackURL.length > 6) {
            fileImageBack = this.dataURLtoFile(this.resultBackURL, 'ine_back' + newID + '.jpeg')
          }
          bodyFormData.append('idUser.idBack', fileImageBack)
        }
        if (this.resultProfileURL !== this.resultAuxProfileURL) {
          const newID = this.$uuid.v4()
          if (this.resultProfileURL !== '' && this.resultProfileURL.length > 6) {
            fileImageProfile = this.dataURLtoFile(this.resultProfileURL, 'avatar' + newID + '.jpeg')
          }
          bodyFormData.append('idUser.avatar', fileImageProfile)
        }
        bodyFormData.set('idUser.first_name', this.first_name)
        bodyFormData.set('idUser.last_name', this.last_name)
        bodyFormData.set('idHouse', this.id_house)
        // datos = {
        //   idUser: idUser,
        //   idHousingUnit: this.id_house
        // }
        const config = {
          method: 'patch',
          url: 'https://residencial-services.intrare.app/principal_resident/' + id,
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language,
            'authorization': 'Token ' + store.getters.getToken
          },
          data: bodyFormData
        }
        axios(config)
          .then(ok => {
            this.loading = false
            this.getMainResidents()
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('mensaje_mainresident_modificado'))
            this.dialog = false
            setTimeout(this.clear, 3000)
          })
          .catch(error => {
            this.loading = false
            console.log(error.response.data)
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              if (error.response.data) {
                this.errores = error.response.data
              }
              if (error.response.data.idUser) {
                this.errores_seg = error.response.data.idUser
              }
            }
          })
      } else {
        this.dialogCellNumberWrong = true
      }
    },
    deleteMainResident () {
      let URL = ''
      if (this.bandPreMainResident === false) {
        URL = 'https://residencial-services.intrare.app/principal_resident/' + this.idMainResidentDelete
      } else {
        URL = 'https://residencial-services.intrare.app/prePrincipalResident/' + this.idMainResidentDelete + '/validate/'
      }
      const config = {
        method: 'delete',
        url: URL,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config).then(ok => {
        console.log('Main Resident con ID = ', this.idMainResidentDelete + ' eliminado Correctamente.')
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('mensaje_mainresident_eliminado'))
        this.getMainResidents()
        setTimeout(this.clear, 3000)
        this.deleteDialog = false
      })
        .catch(error => {
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
      this.bandPreMainResident = false
    },
    moveUpUserToMainResident () {
      this.errores = []
      this.loading = true
      const config = {
        method: 'PATCH',
        url: 'https://residencial-services.intrare.app/principal_resident/make_from_guest/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          idUser: this.emailGuest,
          idHouse: this.id_house
        }
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.getMainResidents()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_cambio_permisos'))
          this.dialogMoveUp = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    clear: function () {
      this.temporalToken = ''
      this.temporalId = ''
      this.confirm = null
      this.alerta = false
      this.errores = []
      this.errores_seg = []
      this.idHouse = 0
      // this.$validator.reset()
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    },
    fillFields (item) {
      this.id_house = item.idHouse
      this.first_name = item.idUser.first_name
      this.last_name = item.idUser.last_name
      this.celular = item.idUser.cellNumber
      this.email = item.idUser.email
      this.email_aux = item.idUser.email
      this.celular_aux = item.idUser.cellNumber
      this.password = ''
      this.confirmation = ''
      this.change_password = false
      this.resultFrontURL = item.idUser.idFront
      this.resultBackURL = item.idUser.idBack
      this.resultProfileURL = item.idUser.avatar
      this.resultAuxFrontURL = item.idUser.idFront
      this.resultAuxBackURL = item.idUser.idBack
      this.resultAuxProfileURL = item.idUser.avatar
      this.band_cellphone = true
    },
    example2: item => (item.street === null ? 'n/a' : item.street) + ' ' + (item.number === null ? 'n/a' : item.number) + ' (' + (item.phone === null ? 'n/a' : item.phone) + ')',
    customFilter (item, queryText) {
      var text = ''
      if (item.number === null || item.number === '') {
        text = 'n/a'
      } else {
        text = item.number.toLowerCase()
      }
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    cleanFields () {
      this.id_house = ''
      this.first_name = ''
      this.last_name = ''
      this.celular = ''
      this.email = ''
      this.email_aux = ''
      this.celular_aux = ''
      this.password = ''
      this.confirmation = ''
      this.change_password = true
      this.resultFrontURL = ''
      this.resultBackURL = ''
      this.resultProfileURL = ''
    },
    example: item => item.first_name + ' ' + item.last_name,
    getCutingFront () {
      console.log('Datos de la imagen = ', this.imageFrontURL.size)
      const canvas = this.$refs.clipperImageFront.clip() // call component's clip method
      this.resultFrontURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      console.log(this.resultFrontURL)
      this.dialogImageFront = false
      this.dialog = true
    },
    getCutingBack () {
      const canvas = this.$refs.clipperImageBack.clip() // call component's clip method
      this.resultBackURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      console.log(this.resultBackURL)
      this.dialogImageBack = false
      this.dialog = true
    },
    getCutingProfile () {
      const canvas = this.$refs.clipperImageProfile.clip() // call component's clip method
      this.resultProfileURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      console.log(this.resultProfileURL)
      this.dialogImageProfile = false
      // this.dialog = true
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    onInput ({ number, isValid, country }) {
      console.log(number.e164)
      console.log(isValid)
      console.log(country)
      this.celular = number.e164
      this.band_cellphone = isValid
    },
    editResident (item) {
      console.log(item)
      this.editedIndex = this.houseInfo[0].residents.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog_residente = true
    },
    getHouseInfo (token) {
      this.loadingSkeleton = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/house/get/principal_resident/data/' + token + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.loadingSkeleton = false
          console.log('Información de la Casa: ')
          this.houseInfo = response.data
          console.log(this.houseInfo[0].residents)
        })
        .catch(error => {
          this.loadingSkeleton = false
          console.log(error)
        })
    },
    getHouseInfoPreMainResident (id) {
      this.loadingSkeleton = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/prePrincipalResident/data/' + id + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.loadingSkeleton = false
          console.log('Información de la Casa: ')
          this.houseInfoPreMainResident = response.data
          console.log(this.houseInfoPreMainResident)
        })
        .catch(error => {
          this.loadingSkeleton = false
          console.log(error)
        })
    },
    getStatusUpdateQRCode () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/housing_unit/info/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.QRCodes = response.data.update_codes
        })
        .catch(error => {
          console.log(error)
        })
    },
    updateQRCodes () {
      this.loadingQRCodes = true
      const config = {
        method: 'patch',
        url: 'https://residencial-services.intrare.app/housing_unit/update/wallpaper/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          update_codes: this.QRCodes
        }
      }
      axios(config)
        .then(ok => {
          // console.log(ok)
          this.loadingQRCodes = false
          this.dialogUpdateQRCodes = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('cambios_aplicados'))
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loadingQRCodes = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    enableDisableMainResident () {
      if (this.enable === true) {
        console.log('Activa Todos los Usuarios')
        const config = {
          method: 'patch',
          url: 'https://residencial-services.intrare.app/enable/' + this.idHouse + '/residents/',
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
            // 'Accept-Language': this.language
          }
        }
        axios(config)
          .then(ok => {
            console.log(ok)
            this.getMainResidents()
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('mensaje_users_activados'))
            this.dialogEnableDisable = false
            setTimeout(this.clear, 3000)
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        if (this.disable === true) {
          console.log('Desactiva Todos los Usuarios')
          const config = {
            method: 'patch',
            url: 'https://residencial-services.intrare.app/disable/resident/' + this.idHouse + '/cantsend/',
            headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
            }
          }
          axios(config).then(ok => {
            console.log(ok)
            this.getMainResidents()
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_color', 'warning')
            this.$store.commit('snackbar_change_message', this.$t('mensaje_users_desactivados'))
            this.dialogEnableDisable = false
            setTimeout(this.clear, 3000)
          })
            .catch(error => {
              console.log(error)
            })
        }
      }
    },
    activateDeleteUsers () {
      if (this.confirm === null) {
        this.dialogConfirm = true
      }
      if (this.confirm === 'true') {
        console.log('Activar Todos los Usuarios')
        this.loading = true
        const config = {
          method: 'patch',
          url: 'https://residencial-services.intrare.app/house/validate/residents/' + this.temporalToken + '/',
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
            // 'Accept-Language': this.language
          }
        }
        axios(config)
          .then(ok => {
            console.log(ok)
            this.loading = false
            this.getMainResidents()
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('mensaje_users_alta'))
            this.dialogInfoMainResidentAndResidents = false
            setTimeout(this.clear, 3000)
          })
          .catch(error => {
            this.loading = false
            console.log(error)
          })
          .finally(() => (this.loading = false))
      } else {
        if (this.confirm === 'false') {
          console.log('Eliminar Todos los Usuarios')
          this.loading = true
          const config = {
            method: 'delete',
            url: 'https://residencial-services.intrare.app/house/validate/residents/' + this.temporalToken + '/',
            headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
            }
          }
          axios(config).then(ok => {
            console.log(ok)
            this.loading = false
            this.getMainResidents()
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_color', 'warning')
            this.$store.commit('snackbar_change_message', this.$t('mensaje_users_baja'))
            this.dialogInfoMainResidentAndResidents = false
            setTimeout(this.clear, 3000)
          })
            .catch(error => {
              console.log(error)
              this.loading = false
            })
        }
      }
    },
    activateDeleteUsersPreMainResident () {
      if (this.confirm === null) {
        this.dialogConfirm = true
      }
      if (this.confirm === 'true') {
        console.log('Activar Todos los Usuarios')
        this.loading = true
        const config = {
          method: 'patch',
          url: 'https://residencial-services.intrare.app/prePrincipalResident/' + this.temporalId + '/validate/',
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
            // 'Accept-Language': this.language
          }
        }
        axios(config)
          .then(ok => {
            console.log(ok)
            this.loading = false
            this.getMainResidents()
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('mensaje_users_alta'))
            this.dialogInfoPreMainResidentAndResidents = false
            setTimeout(this.clear, 3000)
          })
          .catch(error => {
            this.loading = false
            console.log(error)
          })
          .finally(() => (this.loading = false))
      } else {
        if (this.confirm === 'false') {
          console.log('Eliminar Todos los Usuarios')
          this.loading = true
          const config = {
            method: 'delete',
            url: 'https://residencial-services.intrare.app/prePrincipalResident/' + this.temporalId + '/validate/',
            headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
            }
          }
          axios(config).then(ok => {
            console.log(ok)
            this.loading = false
            this.getMainResidents()
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_color', 'warning')
            this.$store.commit('snackbar_change_message', this.$t('mensaje_users_baja'))
            this.dialogInfoPreMainResidentAndResidents = false
            setTimeout(this.clear, 3000)
          })
            .catch(error => {
              console.log(error)
              this.loading = false
            })
        }
      }
    }
  }
}
</script>

<style scoped>
    .edge {
        border-radius: 8px;
        border-color: #2196ff #2196ff #2196ff #2196ff;
        border-width: 3px 3px 3px 3px;
        text-align: center;
        border-style: solid solid solid solid;
    }
    .wrapper{
        width:300px;
        height:300px;
        position: relative;
        margin: 25px auto;
        overflow: hidden;
        border-radius:50%;
        border: 5px solid #2196ff;
    }
    .wrapper img{
        position: relative;
        width:100%;
        height:auto;
    }
    .splash-info {
        background: #ffffff;
        position: relative;
        z-index: 2;
        margin-bottom: 30px;
        text-align: center;
        font-size:15px;
        font-weight:bold;
    }
</style>
